import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {
  RelativeDateTimeFormatsEnum,
  RelativeDateTimeFormatter,
} from '../../../../../../../srcCommon/formatters/dateTime/relativeDateTimeFormatter';
import {buildTeammateDisplayName} from '../../../../../../helpers/modelHelpers';
import {TeammateModel} from '../../../../../../models/api/teammateModel';

/*
 * Props.
 */

export interface SnoozeDropdownReminderProps {
  remindAt: number;
  isTeammateUser: boolean;
  teammate: TeammateModel;
}

/*
 * Style.
 */

const StyledDetailsDiv = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-auto-flow: row;
  grid-column-gap: 6px;
`;

const StyledIconDiv = styled.div`
  grid-column: 1;
  grid-row: 1;
`;

const StyledLineDiv = styled.div`
  grid-column: 2;

  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.medium};
  color: ${(p) => p.theme.palette.orange.shade40};

  line-height: 16px;
  ${ellipsis()};
`;

const StyledBoldSpan = styled.span`
  font-weight: ${fontWeights.bold};
`;

/*
 * Component.
 */

export const SnoozeDropdownReminder: FC<SnoozeDropdownReminderProps> = (props) => {
  const theme = useUserTheme();

  return (
    <StyledDetailsDiv>
      <StyledIconDiv>
        <Icon name="snoozeFilledSmall" color={theme.palette.orange.shade40} />
      </StyledIconDiv>
      {maybeRenderReminderTeammate(props)}
      <StyledLineDiv>
        <Trans id="snooze-reminder-time">
          Reopens in{' '}
          <StyledBoldSpan>
            <RelativeDateTimeFormatter value={props.remindAt} format={RelativeDateTimeFormatsEnum.LONG} />
          </StyledBoldSpan>
        </Trans>
      </StyledLineDiv>
    </StyledDetailsDiv>
  );
};

function maybeRenderReminderTeammate(props: SnoozeDropdownReminderProps) {
  if (props.isTeammateUser) {
    return null;
  }

  return (
    <StyledLineDiv>
      <Trans id="snooze-reminder-teammate">
        Snoozed by <StyledBoldSpan>{buildTeammateDisplayName(props.teammate)}</StyledBoldSpan>
      </Trans>
    </StyledLineDiv>
  );
}
